import { Text, View } from '@react-pdf/renderer';

import { styles } from '../style';

const BuyerFinancing = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Buyer Financing</Text>

      <Text style={styles.text}>
        1. Buyer may elect to make this Agreement contingent upon obtaining
        mortgage financing. Regardless of any contingency in this Agreement, if
        Buyer chooses to obtain mortgage financing, the following terms apply:
      </Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Buyer may obtain mortgage financing from any lender. Buyer is
          encouraged to shop for the best terms and rates.
        </Text>

        <Text style={styles.listItem}>
          2. Buyer is in default if Buyer: provides false financial/employment
          info, fails to cooperate with loan processing (incl. timely
          appraisal), fails to lock interest rate(s) as required, or otherwise
          causes lender rejection.
        </Text>

        <Text style={styles.listItem}>
          3. Within 7 days of Execution Date, Buyer will complete a mortgage
          application (incl. credit reports) to the chosen lender(s). Brokers
          may communicate with lenders to assist and obtain status updates.
        </Text>

        <Text style={styles.listItem}>
          4. Seller will provide access as required by lender(s) to surveyors,
          officials, appraisers, inspectors and insurers’ representatives.
        </Text>

        <Text style={styles.listItem}>
          5. If allowed, Buyer will lock interest rate(s) at or below desired
          levels at least 10 days (excluding holidays) before Settlement Date.
        </Text>

        <Text style={styles.listItem}>
          f. If lender(s) or required insurer demands repairs, Buyer will
          deliver requirements to Seller. Within 7 days of receipt, Seller will
          notify whether Seller will make the repairs at Seller’s expense.
        </Text>

        <View style={styles.list}>
          <Text style={styles.listItem}>
            i. If Seller makes the required repairs to lender/insurer
            satisfaction, Buyer accepts the Property and agrees to the Release
            clause.
          </Text>

          <Text style={styles.listItem}>
            ii. If Seller will not make the required repairs, or fails to
            respond in time, within 7 days Buyer will notify Seller of Buyer’s
            choice to:
          </Text>

          <View style={styles.list}>
            <Text style={styles.listItem}>
              1) Make the repairs at Buyer’s expense (with reasonable access
              granted by Seller), OR
            </Text>
            <Text style={styles.listItem}>
              2) Terminate this Agreement by written notice to Seller, with all
              deposit monies returned per this Agreement.
            </Text>
            <Text style={styles.listItem}>
              3) If Buyer fails to respond/terminate within the stated time,
              Buyer accepts the Property and will make the required repairs.
            </Text>
          </View>

          <Text style={styles.listItem}>
            iii. The Loan-To-Value (LTV) ratio may affect loan eligibility/fees.
            Appraised value (by independent appraiser, subject to underwriting)
            may be used to determine maximum loan amount and can be ≥ Purchase
            Price/market price.
          </Text>
        </View>
      </View>
    </View>
  );
};

export default BuyerFinancing;
